import { useEffect, useRef } from 'react'
import { Collapse, CollapseItem } from 'src/components/collapse'
import { StepCollapseProps } from './accordion.types'
import { itemStyles } from './accordion.styles'

const Accordion = (props: StepCollapseProps) => {
  const collapseRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const shadowRoot = collapseRef.current?.shadowRoot
    const item = shadowRoot?.querySelector('.hot-collapse__item') as HTMLElement
    const itemStyle = document.createElement('style')

    itemStyle.innerHTML = itemStyles.toString()
    item?.prepend(itemStyle)
  }, [])

  return <Collapse ref={collapseRef} {...props} />
}

const CompoundCollapse = Object.assign(Accordion, { CollapseItem })

export default CompoundCollapse
